namespace Solovis.Reports.Parts.Tables.DataTableHelpers {

    /*
     * options:
     *  tableControl: tableControl
     *  close: function () that will be called when dialog closes.
     */
    export class FilteringDialog {

        public _formBuilder: Solovis.UI.InputControls.FormBuilder

        public _tableControl: Solovis.Reports.Parts.Tables.DataTableControl;
        public _column;
        public _closeCallback;
        public _dialog: Solovis.UI.Dialog;


        constructor(options) {
            this._tableControl = options.tableControl;
            if (!this._tableControl) {
                throw "options.tableControl not specified";
            }

            this._column = options.column ? options.column : null;

            this._closeCallback = options.close ? options.close : null;
        }


        public show() {
            let self = this;

            if (this._dialog) {
                return;
            }

            let filterByList = this._tableControl.filterManager.getFilterByList();


            var formDiv = $("<div>");

            let formBuilderDiv = $("<div>").appendTo(formDiv);
            let formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formDiv
            });
            this._formBuilder = formBuilder;

            var filterIdsSeen = {};
            var filterRows = [];
            $(filterByList).each(function (i, filterByEntry) {
                var filterRow = self._createFilterRow(filterByEntry.id);
                if (filterRow) {
                    formBuilder.addEntry(filterRow);
                }

                filterIdsSeen[filterByEntry.id] = true;
            });

            if (this._column && !filterIdsSeen[this._column.id]) {
                // If the initiating column is not in the filters, try to add it.
                var filterRow = self._createFilterRow(this._column.id);
                if (filterRow) {
                    formBuilder.addEntry(filterRow);
                }
            }

            let desiredWidth = Math.min($(window).width() * 0.9, 575);
            let desiredHeight = Math.min($(window).height() * 0.9, 600);

            this._dialog = new Solovis.UI.Dialog({
                container: formDiv,

                title: "Filters",
                autoOpen: true,
                width: desiredWidth,
                height: desiredHeight,
                center: true,
                modal: false,
                destroyOnClose: true,
                actions: ["Close"],

                close: function () {
                    if (self._closeCallback) {
                        self._closeCallback();
                    }
                },

                buttons: [
                    {
                        label: "Cancel",
                        click: function (e) {
                            self._dialog.close();
                        }
                    },
                    {
                        label: "Clear Filters",
                        click: function (e) {
                            self._clearFilters();
                            self._dialog.close();
                        }
                    },
                    {
                        label: "Apply",
                        click: function (e) {
                            self._updateFilterAfterDelay();
                        }
                    },
                    {
                        label: "OK",
                        click: function (e) {
                            self._updateFilterAfterDelay();
                            self._dialog.close();
                        }
                    }                    
                ],

                contentWidthSizer: {
                    setWidth: function (newWidth) {
                        self._formBuilder.setWidth(newWidth);
                    }
                }
            });

            $(this._tableControl).bind("filterFirstChanged", function () {
                self.updateDialogTitle();
            });

            this.updateDialogTitle();
        }

        private updateDialogTitle() {
            let title = "Filters (";
            if (this._tableControl.filterFirst()) {
                title += "applied before grouping/aggregation";
            }
            else {
                title += "applied after grouping/aggregation";
            }
            title += ")";

            this._dialog.title(title);
        }

        public tryAddColumnFilter(colId) {
            let existingEntry = this._formBuilder.tryGetEntryByName(colId);
            if (existingEntry) {
                return
            }

            var newFilterRow = this._createFilterRow(colId);
            if (newFilterRow) {
                this._formBuilder.addEntry(newFilterRow);
            }
        };


        public _createFilterRow(colId): Solovis.UI.InputControls.FormEntryOptions {
            let self = this;

            let col = this._tableControl.columnSet.getColumnById(colId);
            if (!col) {
                return null;
            }

            let sort = this._tableControl.sortManager.getSortById(col.id);
            if (!sort) {
                return null;
            }

            let filterByList = this._tableControl.filterManager.getFilterByList();
            let currentFilter: FilterByEntry = _.find(filterByList, function (f: any) { return f.id == col.id; });

            // TODO: Support other sort data types.

            if (col.dataType === "tagId") {
                let filterEntryOptions: Solovis.UI.InputControls.FormEntryOptions = {
                    name: colId,
                    label: col.getCompositeLabel(),
                    showRemoveEntryLink: true,

                    createEditor: function (createEditorOptions) {
                        createEditorOptions.container
                            .css("padding", "8px")
                            .css("border", "1px solid #ccc");

                        let tagSetFilterDiv = $("<div>").appendTo(createEditorOptions.container);

                        let tagsFilter = null;
                        if (currentFilter && currentFilter.tagsMatch) {
                            tagsFilter = currentFilter.tagsMatch;
                        }

                        let tagSet = self._tableControl.modelEnvironment.tagSets.tryGetById(col.definitionToUse.tagSetId);

                        let tagSetFilter = new Solovis.Reports.TableFilters.TagFilterControl({
                            controlHost: tagSetFilterDiv,
                            tagSet: tagSet,
                            initialState: tagsFilter,
                            onStateChanged: function () {
                                $(editor).trigger("valueChanged");
                            },
                            height: 400
                        });
                        tagSetFilter.setAsCurrentControl();

                        ($(createEditorOptions.container) as any).resizable({
                            handles: "s",
                            minHeight: 80,

                            resize: function (event, ui) {
                                var currentWidth = ui.size.width;
                                var currentHeight = ui.size.height;

                                // Adjust for padding.
                                tagSetFilter.setHeight(currentHeight - 16);
                            }
                        });

                        // Hide the resize grip.
                        $(".ui-icon-gripsmall-diagonal-se", this.resizableContainer).css("background-image", 'url("")')

                        let editor = {
                            getValue: function () {
                                let tagSetFilterState = tagSetFilter.getCurrentState();
                                if (tagSetFilterState) {
                                    return {
                                        id: col.id,
                                        tagsMatch: tagSetFilterState
                                    };
                                }
                                else {
                                    return null;
                                }
                            }
                        };

                        return editor;
                    }
                };

                return filterEntryOptions;
            }
            else if (col.dataType === "valueTypeId") {
                let filterEntryOptions: Solovis.UI.InputControls.FormEntryOptions = {
                    name: colId,
                    label: col.getCompositeLabel(),
                    showRemoveEntryLink: true,

                    createEditor: function (createEditorOptions) {
                        createEditorOptions.container
                            .css("padding", "8px")
                            .css("border", "1px solid #ccc");

                        let valueTypeFilterDiv = $("<div>").appendTo(createEditorOptions.container);

                        let valueTypesFilter = null;
                        if (currentFilter && currentFilter.valueTypesMatch) {
                            valueTypesFilter = currentFilter.valueTypesMatch;
                        }

                        let valueTypeFilter = new Solovis.Reports.TableFilters.ValueTypeFilterControl({
                            controlHost: valueTypeFilterDiv,
                            initialState: valueTypesFilter,
                            onStateChanged: function () {
                                $(editor).trigger("valueChanged");
                            },
                            height: 400
                        });
                        valueTypeFilter.setAsCurrentControl();

                        ($(createEditorOptions.container) as any).resizable({
                            handles: "s",
                            minHeight: 80,

                            resize: function (event, ui) {
                                valueTypeFilter.setHeight(ui.size.height - 16);
                            }
                        });

                        // Hide the resize grip.
                        $(".ui-icon-gripsmall-diagonal-se", this.resizableContainer).css("background-image", 'url("")')

                        let editor = {
                            getValue: function () {
                                let valueTypeFilterState = valueTypeFilter.getCurrentState();
                                if (valueTypeFilterState) {
                                    return {
                                        id: col.id,
                                        valueTypesMatch: valueTypeFilterState
                                    };
                                }
                                else {
                                    return null;
                                }
                            }
                        };

                        return editor;
                    }
                };

                return filterEntryOptions;
            }
            else if (col.dataType === "bool") {
                let filterEntryOptions: Solovis.UI.InputControls.FormEntryOptions = {
                    name: colId,
                    label: col.getCompositeLabel(),
                    showRemoveEntryLink: true,

                    createEditor: function (createEditorOptions) {
                        createEditorOptions.container.css("padding-top", "8px");
                        let boolFilterDiv = $("<div>").appendTo(createEditorOptions.container);

                        let boolFilter = null;
                        if (currentFilter && currentFilter.boolMatch) {
                            boolFilter = currentFilter.boolMatch;
                        }

                        let boolFilterControl = new Solovis.Reports.TableFilters.BoolFilterControl({
                            controlHost: boolFilterDiv,
                            initialState: boolFilter,
                            onStateChanged: function () {
                                $(editor).trigger("valueChanged");
                            }
                        });
                        boolFilterControl.setAsCurrentControl();

                        let editor = {
                            getValue: function () {
                                let boolFilterState = boolFilterControl.getCurrentState();
                                if (boolFilterState) {
                                    return {
                                        id: col.id,
                                        boolMatch: boolFilterState
                                    };
                                }
                                else {
                                    return null;
                                }
                            }
                        };

                        return editor;
                    }
                };

                return filterEntryOptions;
            }
            else if (col.dataType === "currency" || col.dataType === "number" || col.dataType === "percentage" || col.dataType === "integer") {
                let filterEntryOptions: Solovis.UI.InputControls.FormEntryOptions = {
                    name: colId,
                    label: col.getCompositeLabel(),
                    showRemoveEntryLink: true,

                    createEditor: function (createEditorOptions) {
                        let numberFilterDiv = $("<div>").appendTo(createEditorOptions.container);

                        let numberFilter = null;
                        if (currentFilter && currentFilter.numberMatch) {
                            numberFilter = currentFilter.numberMatch;
                        }

                        let numberFilterControl = new Solovis.Reports.TableFilters.NumericFilterControl({
                            controlHost: numberFilterDiv,
                            initialState: numberFilter,
                            percentageMode: col.dataType === "percentage",
                            onStateChanged: function () {
                                $(editor).trigger("valueChanged");
                            }
                        });
                        numberFilterControl.setAsCurrentControl();

                        let editor = {
                            getValue: function () {
                                let numberFilterState = numberFilterControl.getCurrentState();
                                if (numberFilterState) {
                                    return {
                                        id: col.id,
                                        numberMatch: numberFilterState
                                    };
                                }
                                else {
                                    return null;
                                }
                            }
                        };

                        return editor;
                    }
                };

                return filterEntryOptions;
            }
            else if (sort.sortDataType === "string") {
                let filterEntryOptions: Solovis.UI.InputControls.FormEntryOptions = {
                    name: colId,
                    label: col.getCompositeLabel(),
                    showRemoveEntryLink: true,

                    createEditor: function (createEditorOptions) {
                        let filterDiv = $("<div>").appendTo(createEditorOptions.container);

                        let rowValue = null;
                        if (currentFilter && currentFilter.containsText) {
                            rowValue = currentFilter.containsText;
                        }
                        let rowInput = $("<input>").attr("type", "text").val(rowValue).appendTo(filterDiv);

                        $(rowInput).bind("keyup", function () {
                            $(editor).trigger("valueChanged");
                        });

                        let editor = {
                            getValue: function () {
                                let text = rowInput.val();
                                if (text) {
                                    return {
                                        id: col.id,
                                        containsText: rowInput.val()
                                    };
                                }
                                else {
                                    return null;
                                }
                            }
                        };

                        return editor;
                    }
                };

                return filterEntryOptions;
            }
        }


        public _updateFilterAfterDelay = _.debounce(
            function () {
                this._updateFilterByList();
            },
            200);

        public _updateFilterByList() {
            var newFilterByList = [];

            let entryList = this._formBuilder.getEntryList();
            for (let entry of entryList) {
                let filterByEntry = entry.value();
                if (filterByEntry) {
                    newFilterByList.push(filterByEntry);
                }
            }

            this._tableControl.filterManager.updateFilterByList(newFilterByList);
        }

        public _clearFilters() {
            let entryList = this._formBuilder.getEntryList();
            for (let entry of entryList) {
                entry.remove();
            }

            this._tableControl.filterManager.updateFilterByList(null);
        }
    }

}
